import moment from 'moment-timezone'
import React from 'react'
import { Modal } from 'react-bootstrap'
import { Dosage } from '../../../Utils/Utils'

const ViewRX = ({ methods, data }) => {
    const {
        setEPrescriptionViewModal,
    } = methods
    const {
        userdata,
        EPrescriptionViewModal,
    } = data
    return (
        <>
            <Modal show={EPrescriptionViewModal?.open} onHide={() => setEPrescriptionViewModal({ open: false, data: null })} centered>
                <Modal.Body>
                    <div className="modal-body viewdetail">
                        <div className="text-center">
                            <h4 className="modal-title mb-3" >E-prescription Summary</h4>
                        </div>
                        <div className="row">
                            <div className="col-sm-6">
                                <label className="form-label mb-0">E-prescription Number</label>
                                <p>{EPrescriptionViewModal?.data?.prescriptionNumber}</p>
                            </div>
                            <div className="col-sm-6">
                                <label className="form-label mb-0">Date</label>
                                <p>{moment(EPrescriptionViewModal?.data?.startDate).tz(userdata?.timezoneName).format('ll')}</p>
                            </div>
                            <div className="col-sm-6">
                                <label className="form-label mb-0">Medicine</label>
                                <p>{EPrescriptionViewModal?.data?.medicineName}</p>
                            </div>
                            <div className="col-sm-6">
                                <label className="form-label mb-0">Medicine type</label>
                                <p>{EPrescriptionViewModal?.data?.medicineType}</p>
                            </div>
                            <div className="col-sm-6">
                                <label className="form-label mb-0">Standard</label>
                                <p>{Dosage(EPrescriptionViewModal?.data)}</p>
                            </div>

                            <div className="col-sm-6">
                                <label className="form-label mb-0">Strength</label>
                                <p>{EPrescriptionViewModal?.data?.doseAmount + EPrescriptionViewModal?.data?.doseType}</p>
                            </div>
                            <div className="col-sm-6">
                                <label className="form-label mb-0">Duration</label>
                                <p>{EPrescriptionViewModal?.data?.medicineIntakeDurationAmount + " " + EPrescriptionViewModal?.data?.medicineIntakeDurationType}</p>
                            </div>
                            <div className="col-sm-6">
                                <label className="form-label mb-0">Dosage Instructions</label>
                                <p>{EPrescriptionViewModal?.data?.medicineIntakeTime !== "CUSTOM" ? EPrescriptionViewModal?.data?.medicineIntakeTime : EPrescriptionViewModal?.data?.medicineIntakeCustomTime}</p>
                            </div>
                            <div className="col-sm-6">
                                <label className="form-label mb-0">Quantity</label>
                                <p>{EPrescriptionViewModal?.data?.medicineIntakeAmount}</p>
                            </div>
                            <div className="col-sm-12">
                                <label className="form-label mb-0">Notes</label>
                                <p>{EPrescriptionViewModal?.data?.notes ? EPrescriptionViewModal?.data?.notes : "N/A"}</p>
                            </div>
                        </div>
                    </div>

                </Modal.Body>
            </Modal>
        </>
    )
}

export default ViewRX
